/**
 *  Filename ....: globalsearch.component.ts
 *  Created by ..: ianday
 *  on Date .....: 8/28/23
 **/
import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DwUtils } from '../../../components/utils/dw-utils';
import { ValidationResult } from '../../../models/validation-result';
import { SearchQBE } from "../../../models/searchqbe";
import { MatSort } from "@angular/material/sort";
import { ServiceRequestsService } from 'src/app/services/service-requests.service';
import { AgenciesService } from 'src/app/services/agencies.service';
import { ServiceDefService } from 'src/app/services/servicedef.service';
import { Settings } from 'src/app/services/settings';
import { RequestStatus } from 'src/app/models/request-status';

export class dataRecord {
	id: string;
	description: string;
	constructor(id: string, desc: string) {
		this.id = id;
		this.description = desc;
	}
}

@Component({
	selector: 'app-globalsearch',
	templateUrl: './globalsearch.component.html',
	styleUrls: ['./globalsearch.component.css']
})

export class GlobalSearchComponent implements OnInit {

	public MAX_RECORDS = 300;
	public headerSelect: boolean;
	public strErr: string;
	public usersList: any;
	public maxWarn: string;
	public searchQBE: SearchQBE = new SearchQBE();
	public disabledFlag: boolean | null = false;
	public dataSource: MatTableDataSource<any>;
	public customerRecords: any;
	public selectedRecords: any;
	public statusList: any;
	public enableSubmit: boolean | null = false;
	public selected: any;
	public records: any;
	public pagination: string;
	public Idx: number | null = -1;
	public busyCursor = false;
	public noRecordsReturned: boolean = false
	public useDateRecs: any
	public _requestTypes: any;
	public requestTypeDataSource: any;
	public chkReassigned: boolean = false;
	public requestStatusList: RequestStatus[];

	unlimitedAgencyfilter = false;
	showDateOfBirth = false;
	showReAssignedFilter = false;

	showRestrictedStatusFilter = false;
	showUnLimitedStatusFilter = false;

	public displayedColumns = ['select', 'caseNumber', 'caseName', 'agencyName', 'id', 'serviceRequestDesc', 'dateCreated', 'requestStatusDesc'];

	@Output() cancelClicked = new EventEmitter();
	@Output() submitClicked = new EventEmitter<any>();
	@ViewChild(MatSort, { static: true }) sort: MatSort;
	constructor(public serviceRequestsService: ServiceRequestsService, public agenciesService: AgenciesService, private serviceDefService: ServiceDefService) {
		this.records = [];
		this.strErr = '';
		this.maxWarn = '';
		this.requestStatusList = [];
		this.searchQBE.recordLimit = Settings.getInstance().GlobalSearchResultLimitRequests;
	}

	public doInitialize(): void {
		//this.initializeQueryParams();
		this.noRecordsReturned = false;
		DwUtils.setFocus('caseNumberId');

	}
	public initializeQueryParams(): void {
		this.searchQBE = new SearchQBE();
		this.searchQBE.recordLimit = Settings.getInstance().GlobalSearchResultLimitRequests;
	}

	ngOnInit() {
		//this.queryCustomers();
		this.setPagination(0, 0);
		this.statusList = new Array();
		this.statusList.push({ id: 'ALL', description: 'Any Status' });

		/** set up static lists **/
		this.setUseDateDataSource();

		this.unlimitedAgencyfilter = Settings.getInstance().hasPrivilege('REQUEST_GLOBAL_SEARCH_UNLIMITED_AGENCY_FILTER', "EXECUTE") || Settings.getInstance().hasPrivilege('REQUEST_GLOBAL_SEARCH_UNLIMITED_AGENCY_FILTER', "SHOW")
		this.showDateOfBirth = Settings.getInstance().hasPrivilege('REQUEST_GLOBAL_SEARCH_DOB', "SHOW")
		this.showReAssignedFilter = Settings.getInstance().hasPrivilege('REQUEST_GLOBAL_SEARCH_ASSIGNED_ONLY', "SHOW");
		this.showRestrictedStatusFilter = Settings.getInstance().hasPrivilege('REQUEST_GLOBAL_SEARCH_RESTRICTED_STATUS_FILTER', "SHOW");
		this.showUnLimitedStatusFilter = Settings.getInstance().hasPrivilege('REQUEST_GLOBAL_SEARCH_UNRESTRICTED_STATUS_FILTER', "SHOW");

	}
	@HostListener('document:keydown.enter', ['$event'])
	onKeydownHandler(event: KeyboardEvent) {
		this.searchButtonClicked();
	}
	clearWindow() {
		this.clearSearchFields();
		this.records = [];
		this.strErr = '';
		this.setUseDateDataSource();
		this.doInitialize();
		this.initializeQueryParams();
		this.setPagination(0, 0);
		this.statusList = new Array();
		this.statusList.push({ id: 'ALL', description: 'Any Status' });
		this.dataSource = new MatTableDataSource(this.records);
		this.requestStatusList.forEach(status => {
			status.isSelected = false;
		});
	}
	public loadStickyData(){
		if (Settings.getInstance().GlobalSearchQBERequests) {
			this.searchQBE = Settings.getInstance().GlobalSearchQBERequests;
		}
		for(let status of this.requestStatusList){
			for(let storedStatus of this.searchQBE.requestStatusList){
			if(status.id===storedStatus){
				status.isSelected = true;
			}
		}	
		}
		this.records = Settings.getInstance().GlobalSearchResultRequests;
		this.dataSource = new MatTableDataSource(this.records);
	}
	public onShowHandler() {
		this.clearWindow();
		if (this.requestStatusList.length === 0) {
			this.serviceRequestsService.getAllRequestStatuses().subscribe(
				(result1) => {

					if (this.showUnLimitedStatusFilter) {
						this.requestStatusList = result1; // include all
					} else if (this.showRestrictedStatusFilter) {
						this.requestStatusList = result1.filter(s => s.selectable === 1);
					}


					this.serviceRequestsService.getAllServiceRequestTypes().subscribe(
						(result2) => {
							this._requestTypes = result2;
							Settings.getInstance().serviceRequestTypesList = result2;
							this.requestTypeDataSource = [];
							for (let rec of this._requestTypes) {
								this.requestTypeDataSource.push(new dataRecord(rec.description, rec.description));
							}
							this.loadStickyData();
						},
						(error2) => {
							Settings.getInstance().handleError('Error: unable to retrieve request types from the service');
							this.busyCursor = false;
						}
					);
				},
				(error1) => {
					Settings.getInstance().handleError('Error: unable to retrieve request statuses from the service');

				}
			);
		} else{
			this.loadStickyData();
		}



		// this.usersList = Settings.getInstance().usersList;
		this.usersList = [];
		for (const rec of Settings.getInstance().usersList) {
			this.usersList.push(new dataRecord(rec.username, rec.name));
		}

		
	}
	public setUseDateDataSource(): void {
		this.useDateRecs = [];
		this.useDateRecs.push(new dataRecord('created', 'Submit Date'));
		this.useDateRecs.push(new dataRecord('completed', 'Completed Date'));
		this.useDateRecs.push(new dataRecord('lastModified', 'Last Touched Date'));

	}
	public onSortChange(event: any) {
		if (this.dataSource === undefined || this.records === undefined) {
			return;
		}
		try {
			const propComparator = (a: any, b: any) => {
				const propA = this.getPropertyValue(a[event.active]);
				const propB = this.getPropertyValue(b[event.active]);

				if (typeof propA === 'number' && typeof propB === 'number') {
					return event.direction === 'asc' ? propA - propB : propB - propA;
				} else if (propA instanceof Date && propB instanceof Date) {
					return event.direction === 'asc' ? propA.getTime() - propB.getTime() : propB.getTime() - propA.getTime();
				} else {
					const propAStr = propA.toString();
					const propBStr = propB.toString();
					return event.direction === 'asc' ? propAStr.localeCompare(propBStr) : propBStr.localeCompare(propAStr);
				}
			};

			this.records.sort(propComparator);
			this.dataSource.data = this.records;
			this.selectRow();
			this.setPagination(this.Idx, this.dataSource.filteredData.length);
		} catch (e) {
			console.log(e)
		}
	}
	public getPropertyValue(value: any): any {
		// Handle special cases for specific data types (e.g., date)
		// Add more cases as needed based on the data types
		if (value instanceof Date) {
			return value;
		} else {
			return typeof value === 'number' ? value : value ?? '';
		}
	};
	public toggleAllSelected(event): void {

		if (this.dataSource === undefined) {
			return;
		}

		for (const item of this.dataSource.filteredData) {
			item.select = event.checked;
		}

		if (event.checked === true) {
			this.enableSubmit = true;
		}
	}
	public runChecked(event: any): void {

		if (event.checked === true) {
			this.enableSubmit = true;
		}
		else {
			this.dataSource.filteredData.filter(x => x.select === true).length > 1 ? this.enableSubmit = true : this.enableSubmit = false;
		}
	}
	public onItemStatusChange(event: any): void {

		//this.formingQBE.itemStatusParam = event.value;
	}
	public selectRow() {
		this.Idx = this.dataSource.filteredData.findIndex(s => s.id === this.selected.id);
	}
	public onRowClicked(row: any): void {
		this.Idx = this.dataSource.filteredData.findIndex(s => s.id === row.id);
		this.selected = this.dataSource.filteredData[this.Idx];
		this.setPagination(this.Idx, this.records.length);
	}
	public setPagination(idx: number, total: number) {
		if (idx === -1) {
			this.pagination = 'No results';
		}
		this.pagination = (idx + 1) + '/' + total;
	}
	public tableKeyDown(event: KeyboardEvent) {

		const len: number = this.dataSource.filteredData.length;
		if (event.key === 'ArrowDown') {
			if (this.Idx < (len - 1)) {
				this.selected = this.dataSource.filteredData[++this.Idx];
			}
		} else if (event.key === 'ArrowUp') {
			if (this.Idx > 0) {
				this.selected = this.dataSource.filteredData[--this.Idx];
			}
		}
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}
	public searchButtonClicked(): void {

		this.maxWarn = '';
		this.noRecordsReturned = false;
		this.headerSelect = false;
		this.searchQBE.requestStatusList = this.requestStatusList.filter(status => status.isSelected).map(status => status.id);
		this.searchQBE.requestStatusList = this.requestStatusList
			.filter(status => status.isSelected)
			.map(status => {
				if (status.id === 7 || status.shortDescription.toLowerCase().includes("reassign") || status.shortDescription.toLowerCase().includes("re-assign")) {
					// Add your new check here
					this.searchQBE.includeReAssigned = true;
				}
				return status.id;
			});

		if (this.searchQBE.checkDataForQuery() === false) {
			this.strErr = "Error: at least one piece of information is required to start the search";
			DwUtils.setFocus('caseNumberId');
			return;
		}

		let vr: ValidationResult = new ValidationResult();
		vr = this.searchQBE.validateRecord();

		if (vr.error.length > 0) {
			this.strErr = vr.error;
			DwUtils.setFocus(vr.focus_field);
			return;
		}

		this.strErr = '';
		this.records = [];
		this.Idx = -1;
		this.dataSource = new MatTableDataSource(this.records);
		this.busyCursor = true;
		this.serviceRequestsService.searchServiceRequests(this.searchQBE).subscribe(
			(results) => {
				if (results.length === 0) {
					this.noRecordsReturned = true;
				}
				if (results.length === this.searchQBE.recordLimit) {
					this.maxWarn = 'WARNING: Maximum number of records returned (' + this.searchQBE.recordLimit + ')';
				}
				this.records = results;
				for (const rec of this.records) {
					const baseDesc = this.getRequestTypeDesc(rec.serviceRequestTypeId);

					if (rec.serviceDefId) {
						const serviceDef = Settings.getInstance().getServiceDef(rec.serviceDefId);
						rec.serviceRequestDesc = serviceDef ? `${baseDesc}: ${serviceDef.description}` : baseDesc;
					} else {
						rec.serviceRequestDesc = baseDesc;
					}
					rec.requestStatusDesc = this.getRequestStatusDesc(rec.requestStatusId);
					rec.agencyName = this.getAgencyName(rec.agencyId);
				}
				this.dataSource = new MatTableDataSource(this.records);
				this.setPagination(this.Idx, this.dataSource.filteredData.length);
				this.busyCursor = false;
				Settings.getInstance().GlobalSearchQBERequests = this.searchQBE;
				Settings.getInstance().GlobalSearchResultRequests = this.records;
			},
			(error) => {
				Settings.getInstance().handleError(error, 'Search by parameters');
			}
		);
	}
	public getServiceDefDescription(serviceDefId: number) {
		return Settings.getInstance().getServiceDefDescription(serviceDefId);
	}
	public getAgencyName(agencyId: number) {
		return Settings.getInstance().getAgencyName(agencyId);
	}
	public getRequestTypeDesc(paramId: number) {
		if (!Settings.getInstance().serviceRequestTypesList) {
			return;
		}
		for (const rec of Settings.getInstance().serviceRequestTypesList) {
			if (rec.id === paramId) {
				return rec.description;
			}
		}
		return '';
	}
	public getRequestStatusDesc(paramId: number) {
		for (const rec of Settings.getInstance().requestStatuses) {
			if (rec.id === paramId) {
				return rec.shortDescription;
			}
		}
		return '';
	}
	public resetQueryCriteria(): void {

		this.clearSearchFields();
		this.headerSelect = false;
		this.Idx = -1;
		this.noRecordsReturned = false;
		this.records = new Array();
		this.dataSource = new MatTableDataSource<any>();
		this.strErr = '';
		this.maxWarn = '';
		this.busyCursor = false;

		for (let rec of this.requestStatusList) {
			rec.isSelected = false;
		}
		this.setPagination(this.Idx, this.records.length);
		DwUtils.setFocus('caseNumberId');
	}
	public validateSearchFields(): boolean {

		const vr: ValidationResult = this.searchQBE.validateRecord();

		if (vr.error.length > 0) {
			this.strErr = vr.error;
			DwUtils.setFocus(vr.focus_field);
			return false;
		}

		return true;
	}
	public clearSearchFields(): void {
		this.initializeQueryParams();
	}
	public onSubmitClicked(): void {
		this.selectedRecords = new Array();
		this.selectedRecords = this.dataSource.filteredData.filter(x => x.select === true);
		this.submitClicked.emit(this.selectedRecords);
	}
	public onCancelClicked(): void {
		this.cancelClicked.emit();
	}
	public clearLastModifiedBy() {
		this.searchQBE.lastModifiedBy = undefined;
	}
	clearRequestTypeDropDown() {
		this.searchQBE.requestType = undefined;
	}
}
